import { type Vector3Like, Vector3 } from '@seddi/three';
import type { GarmentGeometryPieceDesc } from '@seddi/ui-three-viewer';

/**
 * Compute vertex normals.
 * @param geometry - Geometry.
 */
export const computeVertexNormals = (geometry: GarmentGeometryPieceDesc) => {
  const positions = geometry.position3D;

  const pA = new Vector3();
  const pB = new Vector3();
  const pC = new Vector3();
  const cb = new Vector3();
  const ab = new Vector3();

  // indexed elements
  const indices = geometry.indices;
  const normals = new Float32Array(positions.length);

  for (let i = 0, l = indices.length; i < l; i += 3) {
    const oA = indices[i + 0] * 3;
    const oB = indices[i + 1] * 3;
    const oC = indices[i + 2] * 3;

    pA.fromArray(positions, oA);
    pB.fromArray(positions, oB);
    pC.fromArray(positions, oC);

    cb.subVectors(pC, pB);
    ab.subVectors(pA, pB);
    cb.cross(ab);

    addToArray3(normals, oA, cb);
    addToArray3(normals, oB, cb);
    addToArray3(normals, oC, cb);
  }

  // Normalize normals.
  for (let i = 0, l = normals.length; i < l; i += 3) {
    cb.fromArray(normals, i);
    cb.normalize();
    cb.toArray(normals, i);
  }

  geometry.normals = normals;
};

const addToArray3 = (array: Float32Array, offset: number, value: Vector3Like) => {
  array[offset] += value.x;
  array[offset + 1] += value.y;
  array[offset + 2] += value.z;
};
